<template>
  <div>
    <v-card class="mt-5">
      <div
        class="d-flex align-center px-5 pt-3 justify-space-between align-center"
      >
        <translate class="drawer-right__title my-0 mb-2 font-weight-bold">Information</translate>

        <ButtonEdit
          :text="$gettext('Edit')"
          @click="$emit('click')"
          v-if="isCourseAdmin"
          class="d-flex justify-end"
        />
      </div>
      <div class="location px-5">
        <div class="d-flex align-start" v-if="course && course.totalFollow">
          <v-icon size="18" class="mr-3">fal fa-square-check</v-icon>
          <p v-if="course.totalFollow">
            {{ `${course.totalFollow} ${$gettext("people follow this")}` }}
          </p>
        </div>
        <div class="d-flex align-start" v-if="course && course.website">
          <v-icon size="18" class="mr-3">fal fa-globe</v-icon>
          <p style="word-break: break-all">
            <a
              target="_blank"
              :href="parseLink(course.website)"
              class="text-decoration-none"
            >
              {{ parseLink(course.website) }}
            </a>
          </p>
        </div>
        <div class="d-flex align-start" v-if="course">
          <v-icon size="18" class="mr-3 pt-1">fal fa-location-dot</v-icon>
          <p class="mb-0">
            {{ course.address }}<br />
            {{ course.city }}{{ course.stateRankName ? `, ${course.stateRankName}` : ''}}
          </p>
        </div>
        <div class="d-flex justify-center pb-4">
          <ButtonGoogleMap :countryCode="course.country" :slugCourse="course.slug" :googleUrl="course.googleUrl"/>
        </div>
        <div class="d-flex align-start" v-if="course && course.phone">
          <v-icon size="18" class="mr-3">fal fa-phone</v-icon>
          <p>
            <a
              :href="`tel:${course.phone}`"
              class="text-decoration-none black--text"
              >{{ course.phone }}</a
            >
          </p>
        </div>
      </div>
    </v-card>
    <!-- Social -->
    <SocialCourseCard v-if="course.facebookUrl || course.twitterUrl || course.linkedinUrl || course.instagramUrl || course.youtubeUrl || course.tripadvisorUrl"/>
  </div>
</template>
<script>
import ButtonEdit from "@/components/Buttons/ButtonEdit";
import SocialCourseCard from "@/components/Card/SocialCourseCard";
import ButtonGoogleMap from"@/components/Buttons/ButtonGoogleMap";
export default {
  name: "InfomationCourseCard",
  components: {
    ButtonEdit,
    SocialCourseCard,
    ButtonGoogleMap
  },
  props: {
    isCourseAdmin: { type: Boolean, default: false },
  },
  data() {
    return {};
  },
  methods: {
    parseLink(s) {
      if (!s.match(/^[a-zA-Z]+:\/\//)) {
        s = "http://" + s;
      }
      return s;
    },
  },
  computed: {
    course() {
      return this.$store.state.golfcourse.courseDetail;
    },
  },
};
</script>